import React from 'react';
import {translate} from 'react-i18next';
import {Divider, Form, Input} from 'antd';
import {compose} from 'redux';
import {SPAN_ONE_THIRD, SPAN_TWO_THIRDS} from "../../../../../styles/constants";
import {getStringFromArtefactTriplet, getArtefactTripletFromUrn} from "../../../../../utils/sdmxJson";

const formItemLayout = {
  labelCol: {span: SPAN_ONE_THIRD},
  wrapperCol: {span: SPAN_TWO_THIRDS},
};

const mapPropsToFields = ({attribute, t}) => ({
  id: Form.createFormField({value: attribute !== null ? attribute.id : null}),
  concept:
    Form.createFormField({
      value: attribute !== null
        ? (
          `(${getStringFromArtefactTriplet(getArtefactTripletFromUrn(attribute.conceptIdentity))})`
          + ' ' + attribute.conceptIdentity.split('.')
            .pop()
        )
        : null
    }),
  codelist:
    Form.createFormField({
      value: attribute !== null
        ? (
          attribute.localRepresentation &&
          attribute.localRepresentation.enumeration &&
          getStringFromArtefactTriplet(getArtefactTripletFromUrn(attribute.localRepresentation.enumeration))
        )
        : null
    })
});

const AttributeDetailsMappingSet = ({
                           t,
                           form
                         }) =>
  <Form>
    <Form.Item label={t('data.attribute.id.label')} {...formItemLayout}>
      {form.getFieldDecorator('id')(
        <Input title={form.getFieldValue('id')} disabled/>
      )}
    </Form.Item>
    <Divider/>
    <Form.Item label={t('data.attribute.concept.label')} {...formItemLayout}>
      {form.getFieldDecorator('concept')(
        <Input title={form.getFieldValue('concept')} disabled/>
      )}
    </Form.Item>
    <Form.Item label={t('data.attribute.codelist.label')} {...formItemLayout}>
      {form.getFieldDecorator('codelist')(
        <Input title={form.getFieldValue('codelist')} disabled/>
      )}
    </Form.Item>
  </Form>;

export default compose(
  translate(),
  Form.create({mapPropsToFields})
)(AttributeDetailsMappingSet);
